import { createApi } from '@reduxjs/toolkit/query/react';
import { API_BASEPATH_PORTAL } from '@/config/env.config';
import { createBaseQueryWithAuth } from '../baseQueryWithAuth';

export const portalApi = createApi({
	reducerPath: 'portal',
	tagTypes: ['projects', 'manifests', 'user', 'roles', 'files', 'admin-files', 'contacts', 'samplesets'],
  baseQuery: createBaseQueryWithAuth(API_BASEPATH_PORTAL),
  endpoints: () => ({}),
});